import React, { useState } from "react";
import { Outlet, useLocation } from 'react-router-dom';
import { Layout as AntLayout } from 'antd';
import { ToastContainer } from 'react-toastify';
import Metadata from './metadata';
import Header from './header.js';
import Footer from './footer.js';
import Sidebar from './sidebar.js';
import '../../assets/css/index.css'; 
import '../../assets/css/style.css';
import "../../assets/css/style.bundle.css";
import "../../assets/js/common.js";
import { useAuth } from '../../contexts/AuthContext';

const { Header: AntHeader, Sider, Content, Footer: AntFooter } = AntLayout;

const Layout = () => {
  const { userInfo } = useAuth();
  const auth = userInfo || null;
  const [collapsed, setCollapsed] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const isStudioRoute = location.pathname.startsWith('/organisations');

  return (
    <>
      <style>{`
        .ant-layout-sider-trigger {
          border-right: 1px solid #ddd !important;
        }
        /* Studio route trigger button styles on PC */
        @media (min-width: 769px) {
          .main-studio .ant-layout-sider-trigger {
            background: #061c2f !important;
            border-right: 1px solid #061c2f !important;
            color: rgba(255, 255, 255, 0.65) !important;
          }
          .main-studio .ant-layout-sider-trigger:hover {
            background: #061c2f !important;
            color: rgba(255, 255, 255, 0.85) !important;
          }
        }
        /* Mobile sidebar styles */
        @media (max-width: 768px) {
          .ant-layout-header {
            padding: 0 8px !important;
          }
          .mobile-sidebar-overlay {
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0, 0, 0, 0.45);
            z-index: 2500;
            transition: opacity 0.3s;
          }
          .mobile-sidebar-overlay.show {
            opacity: 1;
          }
          .mobile-sidebar-overlay:not(.show) {
            opacity: 0;
            pointer-events: none;
          }
          .ant-layout-sider {
            transform: translateX(-100%);
            transition: transform 0.3s;
            z-index: 2500 !important;
          }
          .ant-layout-sider.mobile-open {
            transform: translateX(0);
          }
          .ant-layout-sider-trigger {
            display: none;
          }
          .main-content-layout {
            margin-left: 0 !important;
          }
        }
        @media (min-width: 769px) {
          .mobile-sidebar-overlay {
            display: none;
          }
        }
      `}</style>
      <AntLayout style={{ minHeight: '100vh' }} className={`${isStudioRoute ? 'main-studio' : ''}`}>
        <AntHeader style={{ 
        padding: '0 24px',
        background: '#fff',
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1000,
        borderBottom: '1px solid #f0f0f0',
        height: '46px',
        lineHeight: '46px',
        width: '100%'
      }}>
        <Header 
          collapsed={collapsed} 
          onMobileMenuToggle={() => setMobileMenuOpen(!mobileMenuOpen)}
          mobileMenuOpen={mobileMenuOpen}
          sidebarWidth={collapsed ? 80 : 256}
        />
      </AntHeader>
      <div 
        className={`mobile-sidebar-overlay ${mobileMenuOpen ? 'show' : ''}`}
        onClick={() => setMobileMenuOpen(false)}
      />
      <Sider 
        collapsible 
        collapsed={collapsed} 
        onCollapse={setCollapsed}
        width={256}
        theme={isStudioRoute ? 'dark' : 'light'}
        className={mobileMenuOpen ? 'mobile-open' : ''}
        style={{ 
          overflow: 'auto',
          height: 'calc(100vh - 46px)',
          position: 'fixed',
          left: 0,
          top: '46px',
          bottom: 0,
          background: isStudioRoute ? '#061c2f' : '#fff',
          borderRight: isStudioRoute ? 'none' : '1px solid #ddd',
          zIndex: 2500
        }}
      >
        <Sidebar 
          collapsed={collapsed} 
          isStudioRoute={isStudioRoute}
          onCloseMobileMenu={() => setMobileMenuOpen(false)}
        />
      </Sider>
      <AntLayout 
        className="main-content-layout"
        style={{ 
          marginTop: '46px',
          marginLeft: collapsed ? 80 : 256,
          transition: 'margin-left 0.2s',
          minHeight: 'calc(100vh - 46px)',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Content style={{ 
          // padding: '24px',
          flex: 1,
          background: '#fff'
        }}>
          <Outlet />
        </Content>
        <AntFooter style={{ 
          textAlign: 'center',
          background: '#F5F5F5',
          padding: '24px 50px'
        }}>
          <Footer />
        </AntFooter>
      </AntLayout>
      <Metadata />
      <ToastContainer />
    </AntLayout>
    </>
  );
};

export default Layout;